<div class="close closeModal">
  <a (click)="close()" title="cerrar"
    ><span class="cross"></span><span class="sr-only">cerrar</span></a
  >
</div>
<div class="aviso">
  <div class="tituloSearch">{{ 'MENSAJE_DESEA_IMPRIMIR' | translateV2 }}</div>
  <div class="avisoInputWrap" [formGroup]="opcionesImpresionForm">
    <div class="onoffswitch-wrapGeneral">
      <div class="onoffswitch-wrap">
        <div class="onoffswitch">
          <input
            type="checkbox"
            formControlName="imprimirTodo"
            name="onoffswitch03"
            id="myonoffswitch03"
            class="onoffswitch-checkbox"
          />
          <label class="onoffswitch-label" for="myonoffswitch03"></label>
        </div>
        <label class="onoffswitch-label-text" for="myonoffswitch03"
          >{{ 'IMPRIMIR_TODAS' | translateV2 }}</label
        >
      </div>
    </div>
    <div class="checkboxStyledWrap">
      <div
        class="checkboxStyled"
        [ngClass]="{ checked: opcionesImpresionForm.controls.entradas.value }"
      >
        <div class="center">
          <label class="label" for="myCheckboxStyled00">
            <input
              formControlName="entradas"
              class="label__checkbox"
              type="checkbox"
              id="myCheckboxStyled00"
            />
            <span class="label__check">
              <img
                class="svg"
                src="assets/img/checkbox-mark.svg"
                alt="icono checkbox"
              />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyled00">{{ 'ENTRADAS' | translateV2}}</label>
      </div>
      <div
        class="checkboxStyled"
        [ngClass]="{ checked: opcionesImpresionForm.controls.albaran.value }"
      >
        <div class="center">
          <label class="label" for="myCheckboxStyled02">
            <input
              formControlName="albaran"
              class="label__checkbox"
              type="checkbox"
              id="myCheckboxStyled02"
              checked
            />
            <span class="label__check">
              <img
                class="svg"
                src="assets/img/checkbox-mark.svg"
                alt="icono checkbox"
              />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyled02">{{ 'Albaran' | translateV2 }}</label>
      </div>
      <div
        style="display: none"
        class="checkboxStyled"
        [ngClass]="{ checked: opcionesImpresionForm.controls.factura.value }"
      >
        <div class="center">
          <label class="label" for="myCheckboxStyled03">
            <input
              formControlName="factura"
              class="label__checkbox"
              type="checkbox"
              id="myCheckboxStyled03"
              checked
            />
            <span class="label__check">
              <img
                class="svg"
                src="assets/img/checkbox-mark.svg"
                alt="icono checkbox"
              />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyled03">{{ 'FACTURA' | translateV2 }}</label>
      </div>
      <!-- <div class="checkboxStyled" [ngClass]="{'checked' : opcionesImpresionForm.controls.localizador.value}">
              <div class="center">
                <label class="label" for="myCheckboxStyled04">
                  <input
                  formControlName="localizador"
                  class="label__checkbox" type="checkbox" id="myCheckboxStyled04">
                  <span class="label__check">
                    <img class="svg" src="assets/img/checkbox-mark.svg" alt="icono checkbox">
                  </span>
                </label>
              </div>
              <label class="label__text" for="myCheckboxStyled04">LOCALIZADOR</label>
            </div> -->
      <div
        style="display: none"
        class="checkboxStyled"
        [ngClass]="{ checked: opcionesImpresionForm.controls.etiquetas.value }"
      >
        <div class="center">
          <label class="label" for="myCheckboxStyled05">
            <input
              formControlName="etiquetas"
              class="label__checkbox"
              type="checkbox"
              id="myCheckboxStyled05"
            />
            <span class="label__check">
              <img
                class="svg"
                src="assets/img/checkbox-mark.svg"
                alt="icono checkbox"
              />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyled05">{{ 'OPCIONES_PAGO_ETIQUETAS' | translateV2 }}</label>
      </div>
    </div>
  </div>
  <div class="faturacion-fila">
    <div class="ticket-info">
      <div class="inputControl botones">
        <button
          type="button"
          value="cancelar"
          class="cancelar"
          (click)="close()"
        >
          {{ 'CANCELAR' | translateV2 }}
        </button>
      </div>
    </div>
    <div class="ticket-info">
      <div class="inputControl botones">
        <button
          type="button"
          value="ACEPTAR"
          class="pagar aceptar"
          (click)="getOpcionesImpresion()"
        >
          {{ 'ACEPTAR' | translateV2 }}
        </button>
      </div>
    </div>
  </div>

  <div class="wrap-factura">
    <div *ngIf="showEnvioMail"
      [ngClass]="{ 'checkboxStyled': true, 'checked': true }">
        <div class="center">
          <label class="label" for="myCheckboxStyledGes02">
            <input
              class="label__checkbox w-100"
              type="checkbox"
              [(ngModel)]="enviarMail"
              id="myCheckboxStyledGes02"
              (change)="sendMailModal()"
            />
            <span class="label__check">
              <img
                class="svg"
                src="assets/img/checkbox-mark.svg"
                alt="icono checkbox"
              />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyledGes02">{{
          'OPCIONES_PAGO_ENVIO_MAIL' | translate
        }}</label>
    </div>
  </div>

</div>
